export default "__VITE_ASSET__274dbe2b__"